import React, { useState } from "react";
import RichTextEditor from "react-rte";

export default props => {
    const [value, setValue] = useState(RichTextEditor.createValueFromString(props.value, "html"));
    return (
        <RichTextEditor
            value={value}
            onChange={v => {
                setValue(v);
                if (props.onChange) props.onChange(v.toString("html"));
            }}
        />
    );
};
